<sgt-loading-info
    *ngIf="isLoading"
    title="Carregando Título"
    text="Aguarde um momento enquanto estamos carregando o título">
</sgt-loading-info>

<form #form="ngForm" #formElement class="container-form with-nav-tabs" novalidate>
    <!--Options-->
    <div class="row container-form-options" *ngIf="!embedded">
        <div class="col-12">
            <ng-template [ngIf]="config?.canInsert || config?.canEdit">
                <button  type="button" class="btn btn-success mr-2" (click)="saveClick()" id="btnSave">
                    <i class="fas fa-check" aria-hidden="true"></i> Salvar
                </button>
                <button type="button" class="btn btn-light" (click)="cancel()">
                    <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
                </button>
            </ng-template>

            <ng-template [ngIf]="!config?.canEdit">
                <button type="button" class="btn btn-light" (click)="cancel()">
                    <i class="fas fa-times"></i> Fechar
                </button>    
            </ng-template>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content">
        <div class="col-12" *ngIf="isLoadingFinished && !entity">
            <div class="alert alert-info alert-no-entity">
                <h5>
                   <i class="fas fa-info" aria-hidden="true"></i> Nenhum título encontrado
                </h5>
                <p>Verifique se você consultou o título correto e tente novamente</p>
            </div>            
        </div>

        <div class="col-12 container-navs" *ngIf="entity">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-target="#tabTituloReceberPrincipal" data-toggle="tab">Principal</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabTituloReceberPagamentos" data-toggle="tab">Pagamentos</a>
                </li>
                <li class="nav-item" *ngIf="config?.isShowNotas">
                    <a class="nav-link" data-target="#tabTituloReceberNotas" data-toggle="tab">
                        Notas
                    </a>
                </li>                
            </ul>
            <div class="tab-content">
                <!-- Principal -->
                <div class="tab-pane tab-principal active" id="tabTituloReceberPrincipal">
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="numeroErp" class="col-form-label">Número</label>
                            <input type="text" class="form-control" [(ngModel)]="entity.numeroErp" #numeroErp="ngModel" name="numeroErp" id="numeroErp"
                                required="required" [autofocus]="true">
                            <p class="form-text text-muted">
                                Número do título a receber no sistema ERP
                            </p>
                            <sgt-form-control-error
                                *ngIf="numeroErp.errors && numeroErp.errors.required && numeroErp.dirty"
                                msgError="O número é obrigatório">
                            </sgt-form-control-error>                           
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="situacao" class="col-form-label">Situação</label>
                            <sgt-titulo-receber-situacao-select
                                [(ngModel)]="entity.situacao"
                                name="situacao"
                                id="situacao"
                                #situacao="ngModel"
                                required="required">
                            </sgt-titulo-receber-situacao-select>
                            <sgt-form-control-error
                                *ngIf="situacao.errors && situacao.errors.required && situacao.dirty"
                                msgError="A situação é obrigatória">
                            </sgt-form-control-error>
                        </div>                                     
                    </div>
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="dataEmissao" class="col-form-label">Emissão</label>
                            <sgt-datepicker [(ngModel)]="entity.dataEmissao" name="dataEmissao" id="dataEmissao"
                                #dataEmissao="ngModel" [ngControl]="dataEmissao" required="required">
                            </sgt-datepicker>
                            <p class="form-text text-muted">Data de emissão do título</p>                            
                            <sgt-form-control-error
                                *ngIf="dataEmissao.errors && dataEmissao.errors.required && dataEmissao.dirty"
                                msgError="A data de emissão é obrigatória">
                            </sgt-form-control-error>
                        </div>  
                        <div class="form-group col-12 col-md-3">
                            <label for="dataVencimento" class="col-form-label">Vencimento</label>
                            <sgt-datepicker [(ngModel)]="entity.dataVencimento" name="dataVencimento" id="dataVencimento"
                                #dataVencimento="ngModel" [ngControl]="dataVencimento" required="required">
                            </sgt-datepicker>
                            <p class="form-text text-muted">Data de vencimento do título</p>                            
                            <sgt-form-control-error
                                *ngIf="dataVencimento.errors && dataVencimento.errors.required && dataVencimento.dirty"
                                msgError="A data de vencimento é obrigatória">
                            </sgt-form-control-error>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="dataDevolucao" class="col-form-label">Devolução</label>
                            <sgt-datepicker [(ngModel)]="entity.dataDevolucao" name="dataDevolucao" id="dataDevolucao"
                                #dataDevolucao="ngModel" [ngControl]="dataDevolucao">
                            </sgt-datepicker>
                            <p class="form-text text-muted">Data de devolução do título</p>                           
                        </div>                                                                
                    </div>

                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="dataUltimoPagamento" class="col-form-label">Último Pagamento</label>
                            <div class="input-group">
                                <input type="text" class="form-control text-center" [value]="entity.dataUltimoPagamento | date:'dd/MM/yyyy'" name="dataUltimoPagamento" id="dataUltimoPagamento"
                                disabled="disabled" readonly="readonly">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="far fa-calendar-alt" aria-hidden="true"></i></span>
                                </div>                                           
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Dias em Atraso</label>
                            <input type="text" class="form-control text-right" [value]="entity.diasEmAtraso ? entity.diasEmAtraso : ''" name="diasEmAtraso" id="diasEmAtraso"
                                disabled="disabled" readonly="readonly">                        
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col-12 col-md">
                            <label class="col-form-label">Série Nota Fiscal</label>
                            <input type="text" class="form-control" [(ngModel)]="entity.serieNotaFiscal " name="serieNotaFiscal" id="serieNotaFiscal"
                                #serieNotaFiscal="ngModel">   
                            <p class="form-text text-muted">
                                Série da Nota Fiscal de origem deste título
                            </p>                                                     
                        </div>
                        <div class="form-group col-12 col-md">
                            <label class="col-form-label">Nota Fiscal</label>
                            <input type="number" class="form-control text-right" [(ngModel)]="entity.numeroNotaFiscal " name="numeroNotaFiscal" id="numeroNotaFiscal"
                                #numeroNotaFiscal="ngModel">    
                            <p class="form-text text-muted">
                                Número da Nota Fiscal de origem deste título
                            </p>                                                    
                        </div>                                                               
                    </div>                    

                    <div class="row">
                        <div class="form-group col-12">
                            <label class="col-form-label">Cliente</label>
                            <sgt-typeahead-cliente-pessoa [(ngModel)]="entity.pessoa" name="pessoa" id="pessoa"
                                #pessoa="ngModel" #typeaheadCliente [ngControl]="pessoa" required="required"
                                [exibirCadastroIncompleto]="!editMode"
                                [obrigarCompletarCadastroIncompleto]="!editMode"
                                [messageCompletarCadastro]="messageCompletarCadastroCliente"                                        
                                [exibirRevisaoPendente]="true"
                                [cadastroProspect]="true"
                                [cadastroCliente]="true"
                                [cadastroOutros]="true"
                                [selectParticipanteCentralCompras]="true"
                                subTitleSelectParticipanteCentralComprasModal="Selecione o participante da central de compras que deseja adicionar ao título a receber"
                                (entitySelected)="onSelectCliente($event)"
                                (clearEntity)="clearCliente()">
                            </sgt-typeahead-cliente-pessoa>                                  
                            <sgt-form-control-error
                                *ngIf="pessoa.errors && pessoa.errors.required && pessoa.dirty"
                                msgError="O cliente é obrigatório">
                            </sgt-form-control-error>                    
                        </div>
                    </div> 

                    <div class="row" *ngIf="!isRepresentante">
                        <div class="form-group col-12">
                            <label class="col-form-label">Representante</label>
                            <sgt-typeahead-representante [(ngModel)]="entity.representante" name="representante" id="representante"
                                #representante="ngModel" [ngControl]="representante" [situacao]="1" required="required"
                                (entitySelected)="onSelectRepresentante($event)"
                                (clearEntity)="clearRepresentante()">
                            </sgt-typeahead-representante>
                            <sgt-form-control-error
                                *ngIf="representante.errors && representante.errors.required && representante.dirty"
                                msgError="O representante é obrigatório">
                            </sgt-form-control-error>                            
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12 col-md">
                            <label class="col-form-label">Forma de Pagamento</label>
                            <sgt-forma-pagamento-select
                                [(ngModel)]="entity.idFormaPagamento"
                                [(formaPagamento)]="entity.formaPagamento"
                                name="formaPagamento"
                                id="formaPagamento"
                                #formaPagamento="ngModel">
                            </sgt-forma-pagamento-select>                            
                        </div>   
                        <div class="form-group col-12 col-md">
                            <label class="col-form-label">Condição de Pagamento</label>
                            <sgt-condicao-pagamento-select
                                [(ngModel)]="entity.idCondicaoPagamento"
                                [(condicaoPagamento)]="entity.condicaoPagamento"
                                name="condicaoPagamento"
                                id="condicaoPagamento"
                                #condicaoPagamento="ngModel">
                            </sgt-condicao-pagamento-select>
                        </div>                                     
                    </div>

                    <div class="row" *ngIf="configEmpresa?.possuiLocalFaturamento">
                        <div class="form-group col-12">
                            <label for="localFaturamento" class="col-form-label">Local do Faturamento</label>
                            <sgt-local-faturamento-select
                                [(ngModel)]="entity.idLocalFaturamento"
                                [(localFaturamento)]="entity.localFaturamento"
                                name="localFaturamento"
                                id="localFaturamento"
                                #localFaturamento="ngModel"
                                required="required">
                            </sgt-local-faturamento-select>
                            <sgt-form-control-error
                                *ngIf="localFaturamento.errors && localFaturamento.errors.required && localFaturamento.dirty"
                                msgError="O local do faturamento é obrigatório">
                            </sgt-form-control-error>
                        </div>
                    </div>                     

                    <div class="row">
                        <div class="form-group col-12 col-md-4 col-lg-3">
                            <label class="col-form-label">Valor do Título</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>   
                                <sgt-decimal2 [(ngModel)]="entity.valor" name="valor" id="valor"
                                    #valor="ngModel" [ngControl]="valor" required="required">
                                </sgt-decimal2>
                            </div>
                            <sgt-form-control-error
                                *ngIf="valor.errors && valor.errors.required && valor.dirty"
                                msgError="O valor do título é obrigatório">
                            </sgt-form-control-error>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Juros</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>                           
                                <input type="text" class="form-control text-right" [value]="entity.valorJuros | decimalFormat: 1:2:2" name="valorJuros" id="valorJuros"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Multa</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorMulta | decimalFormat: 1:2:2" name="valorMulta" id="valorMulta"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Acrescimo</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorAcrescimo | decimalFormat: 1:2:2" name="valorAcrescimo" id="valorAcrescimo"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div>                                                                                                         
                    </div> 
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Desconto</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorDesconto | decimalFormat: 1:2:2" name="valorDesconto" id="valorDesconto"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Devolução</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorDevolucao | decimalFormat: 1:2:2" name="valorDevolucao" id="valorDevolucao"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Valor Pago</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorPago | decimalFormat: 1:2:2" name="valorPago" id="valorPago"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div>                        
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Renegociado</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorRenegociado | decimalFormat: 1:2:2" name="valorRenegociado" id="valorRenegociado"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div>                        
                    </div>
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Saldo em Aberto</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorSaldo | decimalFormat: 1:2:2" name="valorSaldo" id="valorSaldo"
                                    disabled="disabled" readonly="readonly">
                            </div>
                        </div> 
                        <div class="form-group col-12 col-md-3">
                            <label class="col-form-label">Adimplência</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">R$</span>
                                </div>
                                <input type="text" class="form-control text-right" [value]="entity.valorAdimplencia | decimalFormat: 1:2:2" name="valorAdimplencia" id="valorAdimplencia"
                                    disabled="disabled" readonly="readonly">
                                <div class="input-group-append" *ngIf="entity.percAdimplencia">
                                    <span class="input-group-text">
                                        {{entity.percAdimplencia | decimalFormat: 1:2:2}}%
                                    </span>
                                </div>                                    
                            </div>
                        </div>                                                                                                                     
                    </div>
                    <div class="row">
                        <div class="form-group col-12 col-md-6">
                            <label class="col-form-label">Anotação</label>
                            <textarea class="form-control" [(ngModel)]="entity.anotacao" name="anotacao" id="anotacao" rows="3"></textarea>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label class="col-form-label">Anotação Financeira</label>
                            <textarea class="form-control" [(ngModel)]="entity.anotacaoFinanceira" name="anotacaoFinanceira" id="anotacaoFinanceira" rows="3"></textarea>
                        </div>                
                    </div>                                  
                </div>

                <!-- Pagamentos -->
                <div class="tab-pane tab-pagamentos" id="tabTituloReceberPagamentos">
                    <sgt-titulo-receber-pagamento
                        [entities]="entity.pagamentos">                        
                    </sgt-titulo-receber-pagamento>
                </div>

                <!-- Notas -->
                <div class="tab-pane tab-notas" id="tabTituloReceberNotas" *ngIf="config?.isShowNotas">
                    <div class="tab-notas-body" #notasContent>
                        <sgt-nota-cards
                            #notaCards
                            [canEdit]="config?.canEdit"
                            [canDelete]="config?.canEdit"
                            (afterInsert)="afterInsertNota()">
                        </sgt-nota-cards>
                    </div>
                    <div class="tab-notas-footer" *ngIf="config?.canEdit">
                        <sgt-nota-form-insert
                            #notaFormInsert
                            [idCliente]="entity.idCliente"
                            [idTituloReceber]="entity.id"
                            (insert)="notaCards.insert($event)">
                        </sgt-nota-form-insert>
                    </div>
                </div>                
            </div>
        </div>
    </div>
</form>